<template>
    <div class="partner-wrap">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "Partner"
    }
</script>

<style lang="less" scoped>

</style>